import { action, makeObservable, observable } from 'mobx';
import { gameConfigStore, userSettingsStore } from '@pascal/pascal-core';

import { doBetStore } from './index';
import { defaultJetIndex } from '../enums/uiConfig';

class GameStore {
  time = null;

  initialPassedSecond = null;

  currentRoundPassedSecond = null;

  isAnimationOffOn = 0;

  showMaxWinPopUpData = { 0: false, 1: false, 2: false };

  currentRoundStatus = null;

  oddData = null;

  changeIsAnimState = false;

  isFakeImagesLoaded = false;

  fightersBlowAnim = { 0: null, 1: null, 2: null };

  betCountData = {
    realBetsCount: 0,
    realBetsCashOutCount: 0,
    demoBetsCount: 0,
    demoBetsCashOutCount: 0,
  };

  isRoundFin = false;

  isTabChange = false;

  isBetsClosed = false;

  currentFighterSection = defaultJetIndex;

  numPadData = { isOpen: false, sectionName: null, currentInputValue: null };

  timerDuration = 10;

  isPongReceived = false;

  isUpperLayerShow = false;

  gameState = {
    status: '',
    isInitialLoaded: false,
  };

  roundId = '';

  currentJetsInfo = {};

  constructor() {
    makeObservable(this, {
      time: observable,
      roundId: observable,
      gameState: observable,
      isTabChange: observable,
      isRoundFin: observable,
      isBetsClosed: observable,
      oddData: observable.deep,
      timerDuration: observable,
      isPongReceived: observable,
      numPadData: observable.deep,
      isUpperLayerShow: observable,
      isAnimationOffOn: observable,
      betCountData: observable.deep,
      currentRoundStatus: observable,
      isFakeImagesLoaded: observable,
      initialPassedSecond: observable,
      updatedIsTabChange: action.bound,
      currentJetsInfo: observable.deep,
      fightersBlowAnim: observable.deep,
      currentFighterSection: observable,
      currentRoundPassedSecond: observable,
      showMaxWinPopUpData: observable.deep,
      setTime: action.bound,
      setOddData: action.bound,
      setRoundId: action.bound,
      setGameState: action.bound,
      setNumPadData: action.bound,
      setIsRoundFin: action.bound,
      setIsBetsClosed: action.bound,
      setTimerDuration: action.bound,
      setIsPongReceived: action.bound,
      setCurrentJetsInfo: action.bound,
      setFighterBlowAnim: action.bound,
      setUpperLayerToggle: action.bound,
      updatedBetCountData: action.bound,
      setIsAnimationOffOn: action.bound,
      setIsShowMaxWinPopUpData: action.bound,
      setCurrentRoundStatus: action.bound,
      setInitialPassedSecond: action.bound,
      setActiveCurrentSection: action.bound,
      updateIsFakeImagesLoaded: action.bound,
      autoUpdatedCurrentSection: action.bound,
      setCurrentRoundPassedSecond: action.bound,
    });
  }

  setTime(time) {
    this.time = time;
  }

  setOddData(odd) {
    this.oddData = odd;
  }

  setRoundId(roundId) {
    this.roundId = roundId;
  }

  updatedIsTabChange(isChange) {
    this.isTabChange = isChange;
  }

  setCurrentJetsInfo(data) {
    if (data) {
      this.currentJetsInfo[data.index] = data.currentOdd;
    } else {
      this.currentJetsInfo = {};
    }
  }

  setIsAnimationOffOn(isReset = false) {
    if (!isReset) {
      this.isAnimationOffOn += 1;
    } else {
      this.isAnimationOffOn = 0;
    }
  }

  setIsShowMaxWinPopUpData(isReset, jetIndex) {
    const { currentWinAmountData } = doBetStore;
    const { limits } = gameConfigStore;

    Object.values(currentWinAmountData).forEach((item, index) => {
      if (item >= limits.maxWin && !doBetStore.betData[index].winAmount) {
        this.showMaxWinPopUpData[index] = true;
      }
    });

    if (isReset) {
      this.showMaxWinPopUpData = { 0: false, 1: false, 2: false };
    }

    if (!isReset && (jetIndex || jetIndex === 0)) {
      this.showMaxWinPopUpData[jetIndex] = false;
    }
  }

  setFighterBlowAnim(isInitial = false) {
    const { isAnimationOn } = userSettingsStore;
    if (this.oddData || isInitial) {
      doBetStore.betData.forEach((item) => {
        if (
          item.finishedOdd &&
          typeof this.fightersBlowAnim[item.fighterNumber] === 'object' &&
          isAnimationOn &&
          !isInitial
        ) {
          setTimeout(() => {
            this.fightersBlowAnim = {
              ...this.fightersBlowAnim,
              [item.fighterNumber]: 'isAnimShow',
            };
          }, 1000);
        }

        if (
          item.finishedOdd &&
          !this.fightersBlowAnim[item.fighterNumber] &&
          ((!isAnimationOn && !isInitial) || isInitial)
        ) {
          this.fightersBlowAnim = {
            ...this.fightersBlowAnim,
            [item.fighterNumber]: item.finishedOdd,
          };
        }
      });
    } else {
      this.fightersBlowAnim = { 0: null, 1: null, 2: null };
    }
  }

  setInitialPassedSecond(second) {
    if (second || second === 0) {
      this.initialPassedSecond = second;
    } else {
      this.initialPassedSecond = null;
    }
  }

  setCurrentRoundPassedSecond(second) {
    if (second) {
      this.currentRoundPassedSecond = second;
    } else {
      this.currentRoundPassedSecond = null;
    }
  }

  setCurrentRoundStatus(status) {
    if (status) {
      this.currentRoundStatus = status;
    } else {
      this.currentRoundStatus = null;
    }
  }

  updatedBetCountData(key) {
    if (key) {
      this.betCountData = { ...this.betCountData, [key]: this.betCountData[key] + 1 };
    } else {
      this.betCountData = {
        realBetsCount: 0,
        realBetsCashOutCount: 0,
        demoBetsCount: 0,
        demoBetsCashOutCount: 0,
      };
    }
  }

  setUpperLayerToggle(bool) {
    this.isUpperLayerShow = bool;
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setIsBetsClosed(isBetsClosed) {
    this.isBetsClosed = isBetsClosed;
  }

  setNumPadData(data) {
    this.numPadData = data;
  }

  setActiveCurrentSection(jetIndex) {
    this.currentFighterSection = jetIndex;

    if (!doBetStore.betData[jetIndex].amount) {
      doBetStore.setBetAmount(
        gameConfigStore.limits?.defaultBetAmount || gameConfigStore.limits?.minBet
      );
    }
  }

  autoUpdatedCurrentSection() {
    const nextFighterSection = doBetStore.betData.find(
      (item) =>
        !item.isBetAccepted &&
        !item.isFirstUpdatedSection &&
        !doBetStore.autoBetData[item.fighterNumber].autoBetCount
    );

    if (nextFighterSection?.fighterNumber || nextFighterSection?.fighterNumber === 0) {
      this.setActiveCurrentSection(nextFighterSection.fighterNumber);
    }
  }

  setTimerDuration(timeValue) {
    this.timerDuration = timeValue;
  }

  setIsRoundFin(boolean) {
    this.isRoundFin = boolean;
  }

  setGameState(status) {
    this.gameState = status;
  }

  updateIsFakeImagesLoaded(fakeImagesLoadedCount, fakeImagesCount) {
    this.isFakeImagesLoaded = fakeImagesLoadedCount === fakeImagesCount;
  }
}

export const gameStore = new GameStore();
